import * as React from 'react';
export const IcChallengeReward = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.99 8.99H11c-.55 0-1 .42-1 .93v12.07h4V9.93c0-.52-.45-.94-1.01-.94zM18.98 11.99h-1.96c-.56 0-1.02.42-1.02.93v9.07h4v-9.07c0-.51-.46-.93-1.02-.93zM6.99 15.99H5.01c-.56 0-1.01.39-1.01.86v5.14h4v-5.14c0-.48-.45-.86-1.01-.86zM14.21 3.56l-1.06-.11c-.11 0-.22-.08-.27-.19l-.44-.98a.474.474 0 00-.87 0l-.44.98c-.05.11-.14.19-.27.19l-1.06.11c-.41.05-.57.54-.27.82l.79.71c.08.08.14.19.11.3l-.22 1.03c-.08.41.35.71.71.52l.93-.52c.11-.05.22-.05.33 0l.93.52c.35.19.79-.11.71-.52l-.22-1.03c-.03-.11.03-.22.11-.3l.79-.71c.3-.27.14-.79-.27-.82h-.02z'
      fill='currentColor'
    />
  </svg>
);
